<template>
    <div>
        <h1>Mapped</h1>
        <VendorForm :vendorName="vendorName" :clientName="clientName" :clientId="clientId" :vendorId="vendorId" type="mapped" ref="vendorForm" />
        <CCardBody>
            <CDataTable
                class="sticky-header-table"
                stickyHeader
                striped
                :items="vendorList"
                :fields="vendorField"
                tableFilter
                theadTopSlot=""
                itemsPerPageSelect
                :items-per-page="limit"
                :current-page="currentPage"
                :total-rows="totalRows"
                @page-change="handlePageChange"
                pagination
            >
            </CDataTable>
        </CCardBody>
    </div>
</template>

<script>
import VendorForm from "./VendorForm";
import { storeData } from "../../../store";
import { MAPPED_VENDOR } from "../vendorQueries";

const vendorField = [
    { key: "vendor_catalog", label: "Vendor Catalog" },
    { key: "item_description", label: "Item Description" },
    { key: "total_spend", label: "Total Spend" },
    { key: "prime_category_name", label: "Prime Category" },
    { key: "secondary_category_name", label: "Secondary Category" },
    { key: "sub_category_name", label: "Sub Category" },
];

export default {
    name: "mapped",
    components: {
        VendorForm,
    },
    data() {
        return {
            vendorList: [],
            vendorField: vendorField,
            limit: 5,
            offset: 0,
            currentPage: 1,
            totalRows: 0,
            vendorId: storeData.vendorData.id,
            vendorName: "",
            clientName: "",
            clientId: ""
        };
    },
    methods: {
        handlePageChange(page) {
            this.currentPage = page;
            this.offset = (page - 1) * this.limit;
            this.fetchMappedVendor();
        },

        async fetchMappedVendor() {
            try {
                const { data } = await this.$apollo.query({
                    query: MAPPED_VENDOR,
                    variables: {
                        vendor_identifier: this.vendorId,
                        limit: this.limit,
                        offset: this.offset,
                    },
                });
                this.vendorName = data.spendmd_db_get_vendor_name[0].vendor_name;
                this.clientName = data.spendmd_db_get_vendor_name[0].client_name;
                this.clientId = data.spendmd_db_get_vendor_name[0].client_id;
                this.vendorList = data.spendmd_db_get_mapped_data;
                this.totalRows = data.spendmd_db_get_mapped_data_aggregate.aggregate.count;
            } catch (err) {
                console.error("Error fetching mapped vendor data:", err);
            }
        },
        getVendorForm() {
            const vendorForm = this.$refs.vendorForm.getVendorData();
            return vendorForm;
        }
    },
    mounted() {
        this.fetchMappedVendor();
    },
};
</script>

<style scoped>
.sticky-header-table::v-deep > .table-responsive {
    min-height: 300px;
    height: 320px;
    overflow-y: auto;
    position: inherit;
}

.sticky-header-table::v-deep table > thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: white;
}

.mapped-table-wrapper {
    text-align: center;
}

.mapped-table-wrapper::v-deep > .table-responsive {
    min-height: 300px;
    height: 350px;
    overflow-y: auto;
    position: inherit;
}
</style>
